// PageDateFilter Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class DateFilterTab extends Component {
  static get propTypes () {
    return {
      type: PropTypes.string,
      onChange: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      type: '',
      onChange: null
    }
  }

  constructor (props) {
    super(props)

    this.data = {
      type: props.type || 'month'
    }
  }

  render () {
    const { type } = this.data

    return (
      <div className='date-filtertab'>
        <div
          className={`item${type === 'week' ? ' active' : ''}`}
          onClick={this._onChangeType.bind(this, 'week')}
        >
          <IntlMessage ident='report.header.headerWeekLabel' />
        </div>
        <div
          className={`item${type === 'month' ? ' active' : ''}`}
          onClick={this._onChangeType.bind(this, 'month')}
        >
          <IntlMessage ident='report.header.headerMonthLabel' />
        </div>
        <div
          className={`item${type === 'year' ? ' active' : ''}`}
          onClick={this._onChangeType.bind(this, 'year')}
        >
          <IntlMessage ident='report.header.headerYearLabel' />
        </div>
      </div>
    )
  }

  /* Private functions */
  _onChangeType (type) {
    if (this.data.type === type) {
      return
    }

    this.data.type = type
    this.setState({ dataDate: new Date() })

    if (this.props.onChange) {
      this.props.onChange(type)
    }
  }
}

export default DateFilterTab
